import { buildDeepLinkQuery, type NavigationContext } from '@aegislab/shared';
import { useWindowStore } from './windowStore';
import type { FinanceLedgerFilters } from './financeLedgerFilters';

export { useFinanceLedgerFilters, type FinanceLedgerFilters } from './financeLedgerFilters';

function financeLedgerContext(
  filters: FinanceLedgerFilters & { period: string }
): NavigationContext {
  return {
    financeTab: 'ledger',
    ledgerPeriod: filters.period,
    ledgerPool: filters.budgetType,
    ledgerTeam: filters.teamFilter,
    ledgerReview: filters.reviewOnly ? 'true' : 'false',
  };
}

export function buildFinanceLedgerHref(filters: FinanceLedgerFilters & { period: string }) {
  return `/?${new URLSearchParams(buildDeepLinkQuery('finance', financeLedgerContext(filters)))}`;
}

export function openFinanceLedger(filters: FinanceLedgerFilters & { period: string }) {
  useWindowStore.getState().openWindow('finance', financeLedgerContext(filters));
}
